import React from 'react';
import _ from 'underscore';

export default class UnitTemplateProfileShareButtons extends React.Component {

  urlEncodedMessage() {
    const { text, } = this.props
    return encodeURI(text) ;
  }

  render() {
    const { url, text, } = this.props

    const stuff = [
      {
        icon: 'fa-facebook',
        href: `https://www.facebook.com/share.php?u=${url}`,
        title: 'Share this Activity pack on Facebook',
        action: 'Post',
      },
      {
        icon: 'fa-pinterest',
        href: `https://pinterest.com/pin/create/button/?url=${url}&media=https%3A%2F%2Fassets.quill.org%2Fimages%2Fshare%2Fpinterest.png&description=${this.urlEncodedMessage()}`,
        title: 'Share on Pinterest',
        action: 'Pin',
      }
    ];

    const links = _.map(stuff, hash => (
      <a className="quill-button outlined small grey focus-on-light" href={hash.href} key={hash.title} rel="noopener noreferrer" target="_blank" title={hash.title}>
        <i className={`fab ${hash.icon}`} /><span className="social-action">{hash.action}</span>
      </a>
    ));

    return (
      <div className="share light-gray-bordered-box">
        <header className="share-card-header">
          <strong>Share this Activity Pack</strong>
        </header>
        <div className="share-card-body">
          {links}
        </div>
      </div>
    );
  }
}
